<template>
    <md-tabs class="tabs" :md-active-tab="activeTab" @md-changed="changed" md-dynamic-height ref="tabs">
    <md-tab id="Overview"
            name="Overview"
            :md-label="activeTab === 'Overview' ? i18n.sale_tab_overview() : ''"
            :md-icon="activeTab === 'Overview' ? '' : 'format_list_bulleted'">
      <div class="container container_30 text_small tabs__tab-inner">
        <description-tab :description="description" />
      </div>
    </md-tab>
    <md-tab id="Details"
            name="Details"
            :md-label="activeTab === 'Details' ? i18n.sale_tab_details() : ''"
            :md-icon="activeTab === 'Details' ? '' : 'info_outline'">
      <div class="container container_30 tabs__tab-inner">
        <sale-tab :sale="sale" />
      </div>
    </md-tab>
    <md-tab id="Token"
            name="Token"
            :md-label="activeTab === 'Token' ? i18n.sale_tab_token() : ''"
            :md-icon="activeTab === 'Token' ? '' : 'toll'">
      <div class="container container_30 tabs__tab-inner">
        <token-tab :token="token" :sale="sale"/>
      </div>
    </md-tab>
    <md-tab :ref="'video_tab'"
            id="Banner"
            name="Banner"
            :md-label="activeTab === 'Banner' ? i18n.sale_tab_video() : ''"
            :md-icon="activeTab === 'Banner' ? '' : 'videocam'">
      <div class="container container_30 tabs__tab-inner">
        <sale-banner :sale="sale" />
      </div>
    </md-tab>
    <md-tab ref="update_tab"
            id="Updates"
            name="Updates"
            :md-label="activeTab === 'Updates' ? i18n.sale_tab_updates() : ''"
            :md-icon="activeTab === 'Updates' ? '' : 'autorenew'">
      <div class="container container_30 tabs__tab-inner">
        <updates-tab :sale="sale" />
      </div>
    </md-tab>
    <md-tab ref="doc_tab"
            id="Documents"
            name="Documents"
            :md-label="activeTab === 'Documents' ? i18n.sale_tab_documents() : ''"
            :md-icon="activeTab === 'Documents' ? '' : 'folder'">
      <div class="container container_30 tabs__tab-inner">
        <documents-tab :sale="sale"
                       @is-fund-documents="isFundDocumentsUploaded($event)"
        />
      </div>
    </md-tab>
    <md-tab v-if="sale.isClosed && sale.details.internal_type.toLowerCase() !== 'crowdfunding' && isMy"
            id="Dividends"
            name="Dividends"
            :md-label="activeTab === 'Dividends' ? i18n.sale_tab_dividends() : ''"
            :md-icon="activeTab === 'Dividends' ? '' : 'percent'">
      <div class="container container_30 tabs__tab-inner">
        <dividends-tab :sale="sale"
                       :isDocumentsUploaded="isDocumentsUploaded"
                       @dividends-page-status="setDividendsPage($event)"
                       @show-doc-tab="showDocTab()"
        />
      </div>
    </md-tab>
  </md-tabs>
</template>

<script>
  import DescriptionTab from './tabs/Sales.DescriptionTab'
  import CrowdfundTab from './tabs/Sales.CrowdfundTab'
  import SaleBanner from './components/Sales.Banner'
  import TokenTab from './tabs/Sales.TokenTab'
  import DocumentsTab from './tabs/Sales.DocumentsTab'
  import UpdatesTab from './tabs/Sales.UpdatesTab'
  import SaleTab from './tabs/Sales.SaleTab'
  import DividendsTab from './tabs/Sales.DividendsTab'
  import { i18n } from '@js/i18n'
  import { commonEvents } from '@js/events/common_events'
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'

  export default {
    name: 'sale-details-tabs',
    props: ['sale', 'curTab', 'description', 'syndicate', 'token'],
    data: _ => ({
      activeTab: null,
      i18n,
      isDocumentsUploaded: false
    }),
    components: {
      DocumentsTab,
      DescriptionTab,
      CrowdfundTab,
      SaleBanner,
      TokenTab,
      SaleTab,
      UpdatesTab,
      DividendsTab
    },

    watch: {
      curTab (data) {
        this.activeTab = data
      }
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountId
      ]),
      isMy () {
        return this.sale.owner === this.accountId
      }
    },
    methods: {
      changed (tab) {
        this.activeTab = tab
      },
      setDividendsPage (status) {
        this.$emit(commonEvents.dividendsPageStatus, status)
      },
      isFundDocumentsUploaded (docs) {
        if (docs.length) this.isDocumentsUploaded = true
      },
      showDocTab () {
        let tabs = this.$refs.tabs
        tabs.activeTab = this.$refs['doc_tab'].id
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  /deep/ .md-tab {
    width: 100%;
    min-width: 100%;
    padding: 0;
  }

  .tabs {
    & /deep/ .md-tabs-navigation {
      justify-content: space-between;
    }

    & /deep/ .md-tabs-navigation .md-button {
      min-width: 50px !important;

      .md-ripple {
        padding: 0 12px;

        i {
          color: $col-md-primary;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/Sales.Tabs.vue